import React from 'react';
import Footer from '../Components/Footer';
import Header from '../Components/Header';


const TermsOfService = () => {
    return (
        <div className="bg-white">
            <Header />
            <div className="max-w-4xl mx-auto py-8 px-4 pt-20"> {/* pt-20 추가 */}
                <div className="bg-white shadow-lg rounded-lg">
                    <div className="p-6">
                        <h1 className="text-2xl font-bold mb-8 text-center">SWITCHUP 이용약관</h1>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold mb-4">제1조 (목적)</h2>
                            <p className="text-gray-700 leading-relaxed">
                                본 약관은 SWITCHUPLAB(이하 "회사")가 제공하는 SWITCHUP(이하 "서비스")의 이용 조건 및 절차, 회사와 회원의 권리·의무 및 책임사항을 규정하는 것을 목적으로 합니다.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold mb-4">제2조 (서비스 이용 계약)</h2>
                            <div className="space-y-4">
                                <p className="text-gray-700">1. 서비스 이용 계약은 회원이 본 약관에 동의하고 회사가 승낙함으로써 체결됩니다.</p>
                                <div>
                                    <p className="text-gray-700">2. 회원 가입 시 다음의 정책을 준수해야 합니다:</p>
                                    <ul className="list-disc pl-8 mt-2 space-y-2 text-gray-700">
                                        <li>비밀번호는 8~20자리</li>
                                        <li>영문, 숫자, 특수문자를 모두 포함</li>
                                        <li>개인정보 보호를 위한 안전한 비밀번호 설정</li>
                                    </ul>
                                </div>
                            </div>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold mb-4">제3조 (요금제 및 결제)</h2>
                            <div className="space-y-4 text-gray-700">
                                <p>1. 요금제는 무료와 유료로 구분되며, 상세 내용은 회사 웹사이트의 요금제 페이지에서 확인할 수 있습니다.</p>
                                <p>2. 유료 서비스의 결제는 매월 자동으로 진행되며, 결제일이 존재하지 않는 월의 경우 해당 월의 마지막 날에 결제됩니다.</p>
                                <p>3. 회원은 언제든지 요금제를 변경할 수 있습니다.</p>
                                <p>4. 해당 월에 미사용한 서비스 이용량은 다음 달로 이월되지 않습니다.</p>
                            </div>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold mb-4">제4조 (환불 정책)</h2>
                            <div className="space-y-6">
                                <div>
                                    <h3 className="font-medium mb-2">1. 일반 환불</h3>
                                    <ul className="list-disc pl-8 space-y-2 text-gray-700">
                                        <li>결제 후 7일 이내, 실험 참여 방문자 수를 사용하지 않은 경우 100% 환불</li>
                                        <li>실험 참여 방문자 수를 일부라도 사용한 경우 환불 불가</li>
                                        <li>결제 7일 이후 환불 불가</li>
                                    </ul>
                                </div>
                                <div>
                                    <h3 className="font-medium mb-2">2. 서비스 장애 시 환불</h3>
                                    <ul className="list-disc pl-8 space-y-2 text-gray-700">
                                        <li>24시간 이상 서비스 중단 시, 중단 기간에 비례하여 이용료 환불</li>
                                        <li>회사의 귀책사유로 실험 데이터 손실 또는 실험 결과의 신뢰성이 심각하게 훼손된 경우, 해당 실험에 사용된 방문자 수에 해당하는 금액 환불</li>
                                    </ul>
                                </div>
                                <div>
                                    <h3 className="font-medium mb-2">3. 추가 결제에 대한 환불</h3>
                                    <ul className="list-disc pl-8 space-y-2 text-gray-700">
                                        <li>추가 결제 후 7일 이내, 해당 추가분의 실험 참여 방문자 수를 사용하지 않은 경우에만 100% 환불</li>
                                        <li>추가 결제분의 방문자 수를 일부라도 사용한 경우 환불 불가</li>
                                        <li>추가 결제는 정기 결제와 별도로 환불 정책 적용</li>
                                        <li>추가 결제분의 방문자 수는 정기 결제분 소진 후 사용되며, 구독 기간 말일까지 유효</li>
                                    </ul>
                                </div>
                                <div>
                                    <h3 className="font-medium mb-2">4. 환불 제외 사항</h3>
                                    <ul className="list-disc pl-8 space-y-2 text-gray-700">
                                        <li>고객의 귀책사유로 인한 서비스 이용 불가 또는 실험 실패</li>
                                        <li>실험 설계 오류로 인한 실험 실패</li>
                                    </ul>
                                </div>
                            </div>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold mb-4">제5조 (데이터 처리 및 보관)</h2>
                            <div className="space-y-6">
                                <div>
                                    <h3 className="font-medium mb-2">1. 데이터 소유권 및 책임</h3>
                                    <ul className="list-disc pl-8 space-y-2 text-gray-700">
                                        <li>실험을 통해 수집된 데이터의 소유권은 회원에게 있습니다</li>
                                        <li>회원은 실험 참여자의 개인정보 수집 및 처리에 대한 법적 책임을 집니다</li>
                                        <li>회사는 서비스 제공을 위한 기술적 지원만을 담당합니다</li>
                                    </ul>
                                </div>
                                <div>
                                    <h3 className="font-medium mb-2">2. 데이터 보관 기간</h3>
                                    <ul className="list-disc pl-8 space-y-2 text-gray-700">
                                        <li>Standard 요금제: 6개월</li>
                                        <li>Enterprise 요금제: 12개월</li>
                                    </ul>
                                </div>
                                <div>
                                    <h3 className="font-medium mb-2">3. 데이터 활용</h3>
                                    <ul className="list-disc pl-8 space-y-2 text-gray-700">
                                        <li>회사는 서비스 개선 및 연구 목적으로 회원의 실험 데이터를 활용할 수 있으며, 이 경우 개별 회원을 식별할 수 없는 형태로 처리합니다</li>
                                        <li>회사는 회원의 동의 없이 제3자에게 실험 데이터를 제공하지 않습니다</li>
                                    </ul>
                                </div>
                            </div>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold mb-4">제6조 (서비스 이용 제한)</h2>
                            <div className="space-y-6">
                                <div>
                                    <p className="mb-2">1. 회사는 다음 각 호에 해당하는 경우 서비스 이용을 제한할 수 있습니다:</p>
                                    <ul className="list-disc pl-8 space-y-2 text-gray-700">
                                        <li>불법적인 목적으로 서비스를 사용하는 경우</li>
                                        <li>타인의 권리를 침해하거나 도덕적 기준에 반하는 실험을 진행하는 경우</li>
                                        <li>서비스의 안정적 운영을 방해하는 경우</li>
                                    </ul>
                                </div>
                                <div>
                                    <p className="mb-2">2. 제한 조치</p>
                                    <ul className="list-disc pl-8 space-y-2 text-gray-700">
                                        <li>1차 위반: 경고</li>
                                        <li>2차 위반: 해당 실험 중단</li>
                                        <li>3차 위반: 계정 정지</li>
                                        <li>심각한 위반: 즉시 계정 해지 및 향후 서비스 이용 제한</li>
                                    </ul>
                                </div>
                            </div>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold mb-4">제7조 (회사의 의무)</h2>
                            <div className="space-y-4 text-gray-700">
                                <p>1. 회사는 안정적인 서비스 제공을 위해 노력합니다.</p>
                                <p>2. 회사는 회원의 개인정보를 보호하며, 관련 법령에 따라 처리합니다.</p>
                                <p>3. 회사는 서비스 이용과 관련한 회원의 문의사항이나 불만사항을 처리합니다.</p>
                            </div>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold mb-4">제8조 (계약 해지)</h2>
                            <div className="space-y-4 text-gray-700">
                                <p>1. 회원은 언제든지 서비스 이용계약을 해지할 수 있습니다.</p>
                                <p>2. 계약 해지 후에도 회원이 생성한 데이터는 각 요금제의 보관 기간에 따라 유지됩니다.</p>
                            </div>
                        </section>

                        <section className="mt-12 pt-6 border-t border-gray-200">
                            <p className="text-gray-600 text-sm">
                                부칙 본 약관은 2025년 1월 16일부터 시행합니다.
                            </p>
                        </section>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default TermsOfService;